export default "__VITE_ASSET__Bth6NAnI__"